import React, { Children, useEffect, useRef, useState } from 'react';
import './dotbtn.scss';
import { DotBtnTrigger } from '../../Atoms/DotBtnItem/DotBtnTrigger';
import { useOuterClick } from 'Services/helpers';

export interface DotBtn {
    children: any
}

export const DotBtn = ({children}: DotBtn) => {
    const [isOpen, setOpen] = useState(false);

    const innerRef = useOuterClick(() => setOpen(false));

    return <div className={`btn-dots ${isOpen ? 'open' : ''}`} ref={innerRef}>
        <DotBtnTrigger onClick={() => setOpen(!isOpen)} />
        <div className={'btn-dots__menu'}>
            {children}
        </div>
    </div>;
}
    